// src/redux/slice/homeSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  getHomeProgress,
  getHomeWidgets,
  getHomeCalendar,
} from "../actions/home";

const initialState = {
  progress: {
    data: null,
    isLoading: false,
    error: false,
  },
  widgets: {
    data: [],
    isLoading: false,
    error: false,
  },
  calendar: {
    data: null,
    isLoading: false,
    error: false,
  },
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    resetHomeErrors: (state) => {
      state.progress.error = false;
      state.widgets.error = false;
      state.calendar.error = false;
    },
  },
  extraReducers: (builder) => {
    // -------- PROGRESS ----------
    builder.addCase(getHomeProgress.pending, (state) => {
      state.progress.isLoading = true;
      state.progress.error = false;
    });
    builder.addCase(getHomeProgress.fulfilled, (state, action) => {
      state.progress.isLoading = false;
      state.progress.error = false;
      state.progress.data = action.payload;
    });
    builder.addCase(getHomeProgress.rejected, (state, action) => {
      state.progress.isLoading = false;
      state.progress.error = action.error.message;
    });

    // -------- WIDGETS ----------
    builder.addCase(getHomeWidgets.pending, (state) => {
      state.widgets.isLoading = true;
      state.widgets.error = false;
    });
    builder.addCase(getHomeWidgets.fulfilled, (state, action) => {
      state.widgets.isLoading = false;
      state.widgets.error = false;

      const widgets = action.payload?.widgets || [];
      state.widgets.data = widgets
        .slice()
        .sort((a, b) => a.position - b.position);
    });
    builder.addCase(getHomeWidgets.rejected, (state, action) => {
      state.widgets.isLoading = false;
      state.widgets.error = action.error.message;
    });

    // -------- CALENDAR ----------
    builder.addCase(getHomeCalendar.pending, (state) => {
      state.calendar.isLoading = true;
      state.calendar.error = false;
    });
    builder.addCase(getHomeCalendar.fulfilled, (state, action) => {
      state.calendar.isLoading = false;
      state.calendar.error = false;
      state.calendar.data = action.payload;
    });
    builder.addCase(getHomeCalendar.rejected, (state, action) => {
      state.calendar.isLoading = false;
      state.calendar.error = action.error.message;
    });
  },
});

export const { resetHomeErrors } = homeSlice.actions;
export default homeSlice.reducer;
